require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2004-09-17-dear-economics-professor.json") })
        }
      }, "path---articles-2004-09-17-dear-economics-professor");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2004-09-17-dear-economics-professor!./.cache/json/articles-2004-09-17-dear-economics-professor.json
// module id = 362
// module chunks = 231608221292675